import config from '~/config';

export const formatCondensedHumanDate = (date: Date, includeYear = true, locale: string[] = config.locale) =>
	Intl.DateTimeFormat(locale, {
		day: 'numeric',
		month: 'short',
		year: includeYear && date.getFullYear() !== new Date().getFullYear() ? 'numeric' : undefined,
	})
		.format(date)
		.replace(/ /g, '\xA0');
